import PauseIcon from '@mui/icons-material/Pause'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import {
  LICENSE_STATUSES,
  LicenseRow
} from '@/views/Operators/Operator/Licenses/licenses.dde.table'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { useActionMenuContext } from '../context/ActionMenuContext'

interface ActionToggleOperatorLicenseSuspensionItemProps {
  onClick: (row: LicenseRow) => Promise<void> | void
}

export const ActionToggleOperatorLicenseSuspensionItem = ({
  onClick
}: ActionToggleOperatorLicenseSuspensionItemProps) => {
  const { row } = useActionMenuContext<LicenseRow>()
  const isSuspended = row.status.type === LICENSE_STATUSES.SUSPENDED

  return (
    <ActionMenuDialogItem
      onClick={onClick}
      successMessage={`License for property ${row.property} ${isSuspended ? 'unsuspended' : 'suspended'} successfully`}
      errorMessage={`Failed to ${isSuspended ? 'unsuspend' : 'suspend'} license for property ${row.property}`}
      confirmationMessage={`Are you sure you want to ${isSuspended ? 'unsuspend' : 'suspend'} the license for property ${row.property}?`}
      label={isSuspended ? 'Unsuspend' : 'Suspend'}
      overrideText={isSuspended ? 'Unsuspend License' : 'Suspend License'}
      icon={isSuspended ? <PlayArrowIcon /> : <PauseIcon />}
    />
  )
}
